(function () {
    'use strict';

    angular
        .module('franchiser.components')
        .controller('ApplicationsFranchiserListController', ApplicationsFranchiserListController)

    /** @ngInject */
    function ApplicationsFranchiserListController(ApplicationService, UtilHelper) {
        const vm = this;

        let isTableSearch = false;
        let forcePaginationReset = false;

        vm.isSearchDisabled = () => {
            if ((vm.selectedSearchField && vm.searchText))
                return false;

            return true;
        }

        vm.isClearDisabled = () => {
            if (isTableSearch)
                return false;

            if (vm.selectedSearchField || vm.searchText)
                return false;

            return true;
        }

        vm.doSearch = (event, isFromButton) => {
            if (!vm.isSearchDisabled() && (event && event.keyCode == 13) || isFromButton) {
                forcePaginationReset = true;

                vm.tableCallServer();
            }
        }

        vm.clearSearch = () => {
            vm.selectedSearchField = null;
            vm.searchText = null;

            if (isTableSearch)
                vm.tableCallServer();

            isTableSearch = false;
        }

        vm.tableCallServer = (tableState, stCtrl) => {
            if (!vm.stCtrl && stCtrl)
                vm.stCtrl = stCtrl;

            if (!tableState && vm.stCtrl) {
                vm.stCtrl.pipe();
                return;
            }

            vm.isLoading = true;

            if (forcePaginationReset) {
                tableState.pagination.start = 0;
                forcePaginationReset = false;
            }

            const pagination = tableState.pagination;
            const start = pagination.start || 0;
            const number = pagination.number || 10;

            getApplications(start, number, tableState);
        }

        init();

        function getApplications(skip, perPage, tableState) {
            let parameters = prepareParameters(skip, perPage, tableState);

            ApplicationService
                .getByParameters(parameters)
                .then(success => {
                    vm.applications = success.Registers;
                    tableState.pagination.numberOfPages = success.NumberOfPages;

                    vm.isLoading = false;
                }, error => {
                    vm.companies = null;
                    vm.isLoading = false;
                    UtilHelper.errorCallback(error);
                })
        }

        function prepareParameters(skip, perPage, tableState) {
            let params = {
                Skip: skip,
                PerPage: perPage,
                OrderBy: 'Title',
                OrderDescending: false
            }

            if (tableState.sort.predicate) {
                params.OrderBy = tableState.sort.predicate;
                params.OrderDescending = tableState.sort.reverse;
            }

            if (vm.selectedSearchField && vm.searchText)
                params[vm.selectedSearchField.Value] = vm.searchText;

            return params;
        }

        function init() {
            vm.selectedSearchField;
            vm.searchText;
            vm.isLoading = true;

            vm.searchFields = [{
                Value: 'Name',
                Description: 'Nome ou Descrição'
            }];
        }
    }
}());